export default __webpack_public_path__ + "static/media/kitAlarma1.75f617a1.png";